<template>
  <div class="page" v-loading="loading">
    <div class="page-banner" />
    <div class="page-body">
      <div class="panel panel-up">
        <div class="panel-body theme">
          <el-image class="image" :src="infoData.cover" @error="handleError" />
          <div class="info">
            <div class="panel-title">
              <div class="tit multiple-ellipsis">{{ infoData.title }}</div>
              <div class="sec-box">
                <div class="category_name ellipsis">{{ infoData.category_name }}</div>
                <div class="qrCode-box" @click="generatePoster" title="点击生成分享海报">
                  <el-image :src="shareQrCode" style="width: 120px; height: 120px;">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="qrCode-tip">点击生成海报</div>
                  <!-- 多渠道分享 -->
                  <!-- <div class="share-box">
                    <div class="share-title">分享到</div>
                    <div class="share-icons">
                      <div class="share-item" @click="shareToWechat">
                        <i class="el-icon-chat-dot-round" style="color: #07C160;"></i>
                        <span>微信</span>
                      </div>
                      <div class="share-item" @click="shareToQQ">
                        <i class="el-icon-chat-line-round" style="color: #12B7F5;"></i>
                        <span>QQ</span>
                      </div>
                      <div class="share-item" @click="shareToWeibo">
                        <i class="el-icon-chat-square" style="color: #E6162D;"></i>
                        <span>微博</span>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="msg-list">
              <div class="msg-item">
                <!-- <el-image class="icon" src="@/assets/home/calendar_1.png" fit="cover"></el-image> -->
                <img class="icon" src="@/assets/home/calendar_1.png" />
                <div class="title">
                  <span class="tit">活动开始时间:</span>
                </div>
                <div class="content">{{ infoData.start_time | dateFormat }}</div>
              </div>
              <div class="msg-item">
                <img class="icon" src="@/assets/home/calendar_1.png" />
                <div class="title">
                  <span class="tit">活动结束时间:</span>
                </div>
                <div class="content">{{ infoData.end_time | dateFormat }}</div>
              </div>
              <div class="msg-item">
                <img class="icon" src="@/assets/home/place.png" />
                <div class="title">
                  <span class="tit">活动地点:</span>
                </div>
                <div class="content ellipsis">{{ infoData.address }}</div>
              </div>
              <div class="msg-item" v-if="infoData.live_url">
                <img class="icon" src="@/assets/home/broadcast.png" />
                <div class="title">
                  <span class="tit">直播链接:</span>
                </div>
                <div class="content">
                  <el-button type="text" class="liveBtn">{{ infoData.live_url }}</el-button>
                  <el-popover placement="top-start" width="200" trigger="hover">
                    <el-image :src="qrCode" style="width: 200px; height: 200px;">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <el-button type="text" slot="reference">
                      <img class="icon" src="@/assets/home/code.png" />
                    </el-button>
                  </el-popover>
                  <el-popover placement="top-start" width="200" trigger="hover">
                    <div>
                      <span>{{ infoData.live_url }}</span>
                      <span class="el-icon-copy-document"
                        style="cursor: pointer; margin-left: 12px; font-size: 18px; color: #005cbb;"
                        @click="handleCopy"></span>
                    </div>
                    <el-button type="text" slot="reference">
                      <img class="icon" src="@/assets/home/share.png" />
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
            <div class="action-btns">
              <template v-if="isNeedApply && today < infoData.end_time">
                <template v-if="!formStatus">
                  <span v-if="infoData.max_apply_count === 0" style="padding-right: 20px;">
                    <el-button type="primary" round @click="handleApply()">活动报名</el-button>
                  </span>
                  <span v-else style="padding-right: 20px;">
                    <el-button type="primary" round :disabled="infoData.max_apply_count <= infoData.join_count"
                      @click="handleApply()">活动报名</el-button>
                  </span>
                </template>
                <template v-else>
                  <el-button type="primary" round plain :loading="isJoin" @click="cancelApply()">
                    <span style="color: #999;">已报名</span>
                    <span style="padding: 0px 6px;">|</span>
                    <span>取消</span>
                  </el-button>
                </template>
              </template>
              <el-button type="primary" icon="el-icon-receiving" plain round :loading="isCollectLoad"
                @click="handleCollect()">{{
                  formCollect ? '取消采集' : '采集到云库' }}</el-button>
              <el-button type="primary" icon="el-icon-picture" round plain :loading="posterLoading"
                @click="generatePoster">生成分享海报</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="panel panel-down">
        <div class="panel-head">
          <div class="panel-title">活动说明</div>
        </div>
        <div class="panel-body">
          <template v-if="infoData.introduce_type === 1">
            <el-link type="primary" :href="infoData.introduce_link" target="_blank">{{ infoData.introduce_link
            }}</el-link>
          </template>
          <template v-else>
            <div class="html-view" v-html="infoData.content"></div>
          </template>
          <div class="poster-cont">
            <el-image class="image" :src="infoData.poster" @error="handleError" />
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗-报名 -->
    <Customdialog ref="dialogJoin" class="dialog" title="活动报名" :width="dialogWidth" type="from">
      <div slot="dialogbody" class="dialogBody">
        <div v-if="!usernumber" style="text-align: center;">请先登录</div>
        <el-form ref="ruleForm" class="form-box" :model="ruleForm" :rules="formRules">
          <el-form-item :label="item.field_name" v-for="(item, inx) in formList" :key="inx"
            :prop="item.is_fill ? `${item.field_name}` : ''">
            <!--字段类型，0：文本框，1：单选，2：多选，3：日期，4：附件，5：数字框-->
            <!--文本框-->
            <template v-if="item.field_type === 0">
              <template v-if="item.field_name === '性别'">
                <el-select v-model="ruleForm[item.field_name]" :placeholder="item.tips">
                  <el-option v-for="item in item.field_value" :key="item.key" :label="item.value"
                    :value="item.key"></el-option>
                </el-select>
              </template>
              <template v-else>
                <el-input v-model="ruleForm[item.field_name]" :placeholder="item.tips"></el-input>
              </template>
            </template>
            <!--单选-->
            <template v-else-if="item.field_type === 1">
              <el-radio-group v-model="ruleForm[item.field_name]">
                <el-radio v-for="(el, indx) in item.field_value" :key="indx" :label="el.key">{{ el.value }}</el-radio>
              </el-radio-group>
            </template>
            <!--多选-->
            <template v-else-if="item.field_type === 2">
              <el-checkbox-group v-model="ruleForm[item.field_name]">
                <el-checkbox v-for="(el, indx) in item.field_value" :key="indx" :label="el.key">{{ el.value
                }}</el-checkbox>
              </el-checkbox-group>
            </template>
            <!--日期-->
            <template v-else-if="item.field_type === 3">
              <el-date-picker class="time-content" v-model="ruleForm[item.field_name]" value-format="timestamp"
                type="datetime" :placeholder="`请选择${item.field_name}`"
                @change="(data) => { return selectDate(data, inx) }"></el-date-picker>
            </template>
            <!--附件-->
            <template v-else-if="item.field_type === 4">
              <!-- <Upload
                v-loading="item.completed"
                element-loading-text="文件正在上传，请勿关闭浏览器或刷新页面..."
                :files="item.fileList"
                :sliceFiles="sliceFiles"
                @setUrl="(data) => {return getUrl(data, inx)}"
                :module="'user,avatar'"
                :completed="item.completed"
                :multiple="false"
                :is-edit="true"
              />-->
              <UploadFiles :files="item.fileList" :module="'user,avatar'"
                @setUrl="(data) => { return getUrl(data, inx) }" />
            </template>
            <!--数字框-->
            <template v-else-if="item.field_type === 5">
              <el-input v-model="ruleForm[item.field_name]" oninput="value=value.replace(/[^0-9.]/g,'')"
                class="num-content" />
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div slot="dialogfooter" class="dialogFoot">
        <el-button type="primary" size="medium" plain @click="dialogCancle('ruleForm')">取消</el-button>
        <el-button v-if="usernumber" type="primary" size="medium" :loading="isJoin"
          @click="dialogSubmit('ruleForm')">提交</el-button>
        <el-button v-else type="primary" size="medium" @click="handleLogin">去登录</el-button>
      </div>
    </Customdialog>

    <!-- 隐藏的海报生成容器：内容全部取自活动详情，底部二维码为详情页地址 -->
    <div class="poster-maker" ref="posterMaker">
      <div class="poster-bg">
        <!-- <div class="poster-avatar">
          <img :src="posterAvatar" />
        </div> -->
        <div class="poster-card">
          <!-- <div class="poster-author">@{{ posterAuthor }}</div> -->
          <div class="poster-title">{{ infoData.title }}</div>
          <div class="poster-divider">
            <i class="dot dot-l"></i>
            <i class="line"></i>
            <i class="dot dot-r"></i>
          </div>
          <div class="poster-subtitle">{{ infoData.category_name }}</div>
          <div class="poster-cover">
            <img :src="posterCover" />
          </div>
          <div class="poster-footer">
            <div class="poster-info">
              <div class="poster-info-item">
                <span class="label">活动开始时间：</span>
                <span class="value">{{ posterTime(infoData.start_time) }}</span>
              </div>
              <div class="poster-info-item">
                <span class="label">活动结束时间：</span>
                <span class="value">{{ posterTime(infoData.end_time) }}</span>
              </div>
              <div class="poster-info-item">
                <span class="label">活动地点：</span>
                <span class="value">{{ infoData.address }}</span>
              </div>
            </div>
            <div class="poster-qrcode">
              <img :src="activityQrCode" />
              <span class="poster-qrcode-tip">扫码查看详情</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 海报预览弹窗 -->
    <el-dialog :visible.sync="posterVisible" :show-close="true" :close-on-click-modal="true" :width="widthDialog"
      custom-class="poster-dialog" :append-to-body="true" center>
      <div class="poster-preview" v-loading="posterLoading">
        <img :src="posterImg" style="width: 100%;" />
      </div>
      <div slot="footer" class="poster-tip" @click="savePoster">长按图片保存分享</div>
    </el-dialog>
  </div>
</template>
<script>
/* 引入组件 */
import Customdialog from "@/components/customdialog.vue"
// import Upload from '@/components/upload-sliceFiles.vue'
import UploadFiles from '@/components/upload-files.vue'
/* 引用方法 */
import dayjs from "dayjs"
import { validatePhone, validEmail, validAlphabets, validNumber, validHanZi, validSpecialChar } from "@/utils/validate"
/* Api接口 */
import { getActivityInfo, getActivityFormInfo, revokeJoinActivity, joinActivity, getActivityJoinInfo } from "@/api/activity"
import { setCollect } from "@/api/common"
import {
  symbolReverseEscape,
  clearHtmlString,
  arrangeImages,
  arrangeVideos,
} from "@/utils/correction"
import QRCode from "qrcode"
import html2canvas from "html2canvas"
import { getToken } from "@/utils/auth"
const request_base_path = require("@/utils/base_url")
import wx from 'weixin-js-sdk'
// 校验规则
const validateMobile = (rule, value, callback) => {
  if (!validatePhone(value)) {
    callback(new Error("请输入正确的手机号!"))
  } else {
    callback()
  }
}
const validateEmail = (rule, value, callback) => {
  if (!validEmail(value)) {
    callback(new Error("请输入正确的邮箱!"))
  } else {
    callback()
  }
}
const validateNumber = (rule, value, callback) => {
  if (!validNumber(value)) {
    callback(new Error("请输入数字!"))
  } else {
    callback()
  }
}
const validateAlpha = (rule, value, callback) => {
  if (!validAlphabets(value)) {
    callback(new Error("请输入字母!"))
  } else {
    callback()
  }
}
const validateCN = (rule, value, callback) => {
  if (!validHanZi(value)) {
    callback(new Error("请输入汉字!"))
  } else {
    callback()
  }
}
const validateSpecialChar = (rule, value, callback) => {
  if (!validSpecialChar(value)) {
    callback(new Error("请输入特殊符号!"))
  } else {
    callback()
  }
}
export default {
  name: "ActivityDetail",
  components: {
    Customdialog,
    // Upload,
    UploadFiles
  },
  data() {
    return {
      token: getToken() ? true : false,
      queryObj: {}, // 路由传参
      infoData: {},
      formList: [], // 当前活动表单所需提交项目的集合
      userFormList: [], // 用户上次提交表单的缓存数据
      loading: false,
      defaultImg: require("@/assets/default/image02.jpg"),
      isJoin: false, // 报名防抖
      ruleForm: {}, // 表单数据
      formRules: {},
      // fileList: [],
      files: [],
      today: "",
      sliceFiles: true, // 是否是分片上传
      // completed: false,
      formStatus: false,
      formCollect: false,
      isCollectLoad: false,
      isNeedApply: false, // 是否需要报名
      qrCode: "",
      activityQrCode: "",
      shareQrCode: "", // 页面展示二维码：扫码直达海报分享页
      usernumber: localStorage.getItem("usernumber"),
      posterImg: "", // 生成的海报图片
      posterVisible: false, // 海报弹窗显示
      posterLoading: false, // 海报生成loading
      posterLogo: require("@/assets/home/logo.png"),
      widthDialog: "20%", // 海报弹窗宽度
    }
  },
  filters: {
    dateFormat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
  },
  watch: {
    userFormList: {
      handler(newV) {
        if (newV.length) {
          for (let i = 0; i < newV.length; i++) {
            const item = newV[i]
            if (this.formList.length) {
              this.formList.map(el => {
                if (item.form_field_id === el.id) {
                  el.old_form_value = item.user_form_value
                  el.user_form_value_id = item.user_form_value_id
                }
              })
            } else {
              break
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    formList: {
      handler(newV) {
        if (newV.length) {
          this.updateForm(newV)
        }
      },
      immediate: true,
      deep: true
    },
    infoData: {
      handler(newV) {
        if (newV?.live_url) {
          this.creatQrCode(newV.live_url)
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.queryObj = this.$route.query || {}
    // alert(this.queryObj.share)
    this.today = parseInt((new Date()).getTime() / 1000)
    // 判断是手机端还是pc端
    this.is_mobile()
  },
  mounted() {

    let that = this
    that.getInfo()
    if (that.token) that.getFormInfo()
    that.$nextTick(() => {
      let detailUrl = `${request_base_path.pro_url}#/home/activity/detail?id=${that.queryObj.id}`
      // 海报内二维码：扫码查看活动详情
      that.initCreatQrCode(detailUrl)
      // 页面展示二维码：扫码直达分享图片页（自动生成海报，可直接下载）
      QRCode.toDataURL(`${request_base_path.pro_url}#/activity/share?id=${that.queryObj.id}`).then((url) => {
        that.shareQrCode = url
      })
    })
  },
  computed: {
    dialogWidth() {
      if (window.innerWidth <= 640) {
        return '90%'
      } else if (window.innerWidth <= 1200) {
        return '60%'
      }
      return '40%'
    },
    // 海报署名：当前登录用户昵称
    // posterAuthor() {
    //   return this.$store.state.username || "文化活动云平台"
    // },
    // 海报头像：当前登录用户头像，未登录时回退为站点 logo
    // posterAvatar() {
    //   return this.toSameOrigin(this.$store.state.useravater) || this.posterLogo
    // },
    // 海报封面：转成同源地址，避免 html2canvas 因跨域无法读取像素
    posterCover() {
      return this.toSameOrigin(this.infoData.cover) || this.defaultImg
    }
  },
  methods: {
    is_mobile() {
      // if (this.is_mobile()) {
      //   return true
      // }
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.widthDialog = "90%"
      } else {
        this.widthDialog = "40%"
      }
    },
    // 海报时间格式：2026.09.01 08:00
    posterTime(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY.MM.DD HH:mm")
    },
    // 开发环境下把远程图片地址转为同源相对地址，走 devServer 代理，
    // 这样 html2canvas 才能读取像素；生产环境前后端同域，直接返回原地址
    toSameOrigin(url) {
      if (!url || process.env.NODE_ENV !== "development") return url
      const remote = new URL(request_base_path.dev_url).origin
      if (!url.startsWith(remote)) return url
      return url.slice(remote.length)
    },
    async initCreatQrCode(url) {
      this.activityQrCode = await QRCode.toDataURL(url)
    },
    // 生成分享海报
    async generatePoster() {
      if (!this.infoData.title) {
        this.$message.warning("活动信息加载中，请稍后再试")
        return
      }
      this.posterVisible = true
      this.posterLoading = true
      this.posterImg = ""
      try {
        await this.loadPosterImage()
        const el = this.$refs.posterMaker
        const canvas = await html2canvas(el, {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          backgroundColor: null,
          logging: false,
          width: el.offsetWidth,
          height: el.offsetHeight,
        })
        this.posterImg = canvas.toDataURL("image/png")
      } catch (error) {
        console.error("海报生成失败", error)
        this.$message.error("海报生成失败，请重试")
      } finally {
        this.posterLoading = false
      }
    },
    // 预加载海报封面图，避免 html2canvas 读取时图片未完成加载导致空白
    loadPosterImage() {
      return new Promise((resolve) => {
        // 使用与海报 DOM 相同的同源地址，保证缓存命中且不触发跨域
        const cover = this.posterCover
        const img = new Image()
        let resolved = false
        const done = () => {
          if (resolved) return
          resolved = true
          resolve()
        }
        img.onload = done
        img.onerror = done
        img.src = cover
        setTimeout(done, 1200)
      })
    },
    savePoster() {
      // 保存海报
      const link = document.createElement("a")
      link.href = this.posterImg
      link.download = `${this.infoData.title}.png`
      link.click()

    },
    updateForm(data) {
      let objKey = {}
      let objRule = {}
      data?.forEach(item => {
        objRule[item.field_name] = [ // 给表单添加校验
          { required: true, message: `${item.tips || item.field_name}`, trigger: "blur" }
        ]
        if (item.field_value && !Array.isArray(item.field_value)) {
          item.field_value = JSON.parse(item.field_value)
        }
        if (item.field_type === 0) {
          if (item.special_type === 1) { // 邮箱校验规则
            objRule[item.field_name].push({ required: true, validator: validateEmail, trigger: "blur" })
          } else if (item.special_type === 2) { // 手机校验规则
            objRule[item.field_name].push({ required: true, validator: validateMobile, trigger: "blur" })
          } else { // 非手机/邮箱规则
            switch (item.rule_value) { //输入规则，0：无限制，1：数字，2：字母，3：汉字，4：特殊符号
              case '1':
                objRule[item.field_name].push({ required: true, validator: validateNumber, trigger: "blur" })
                break
              case '2':
                objRule[item.field_name].push({ required: true, validator: validateAlpha, trigger: "blur" })
                break
              case '3':
                objRule[item.field_name].push({ required: true, validator: validateCN, trigger: "blur" })
                break
              case '4':
                objRule[item.field_name].push({ required: true, validator: validateSpecialChar, trigger: "blur" })
                break
              default:
                break
            }
          }
          objKey[item.field_name] = item.old_form_value ? item.old_form_value : ""
        } else if (item.field_type === 1) {
          objKey[item.field_name] = item.old_form_value ? item.old_form_value : 'A'
        } else if (item.field_type === 2) { // 多选
          objKey[item.field_name] = item.old_form_value ? JSON.parse(item.old_form_value) : []
        } else if (item.field_type === 3) { // 日期
          objKey[item.field_name] = item.old_form_value ? Number(item.old_form_value) * 1000 : new Date().getTime()
        } else if (item.field_type === 4) { // 附件
          // item.completed = false
          let file = []
          file = item.old_form_value ? JSON.parse(item.old_form_value) : []
          objKey[item.field_name] = file
          item.fileList = file
        } else {
          objKey[item.field_name] = item.old_form_value ? item.old_form_value : ""
        }
      })
      this.ruleForm = Object.assign({}, objKey)
      this.formRules = Object.assign({}, objRule)

    },
    getFormInfo() {
      let params = {
        id: this.queryObj?.id ?? ""
      }
      getActivityFormInfo(params).then(res => {
        if (res.code === 0) {
          res.data?.map(item => {
            item.old_form_value = ""
          })
          this.formList = res.data
          this.getJoinInfo()
        }
      }).catch(() => { })
    },
    // 获取详情信息
    getInfo() {
      this.loading = true
      const params = { id: this.queryObj?.id ?? "" }
      return getActivityInfo(params).then((res) => {
        this.loading = false
        if (res.code === 0) {
          if (res.data.is_need_apply) { // 是否需要报名，0：否，1：是
            // join_activity_status // null/0：没报过名；3：被撤回；6：自己撤回，可以继续报名
            this.isNeedApply = true
            this.formStatus = (!res.data.join_activity_status || res.data.join_activity_status === 3 || res.data.join_activity_status === 6) ? false : true
          } else {
            this.isNeedApply = false
          }
          this.formCollect = res.data.is_collect_activity ? true : false
          let resContent = this.AutoCorrection(res.data.content)
          this.infoData = res.data
          this.infoData.content = resContent
        }
      }).catch(() => { })
    },
    getJoinInfo() {
      let params = { id: this.queryObj?.id ?? "" }
      getActivityJoinInfo(params).then((res) => {
        if (res.code === 0) {
          // res.data.forEach(item => {
          //   item.user_form_value = JSON.parse(item.user_form_value)
          // })
          this.userFormList = res.data || []
        }
      }).catch(() => { })
    },
    // 当图片加载失败时，将图片地址设置为默认图片
    handleError(e) {
      e.target.src = this.defaultImg
    },
    handlePosterCoverError(e) {
      if (e.target.src !== this.defaultImg) {
        e.target.src = this.defaultImg
      }
    },
    // 复制链接
    handleCopy() {
      let copyInput = document.createElement("input")
      copyInput.value = this.infoData.live_url
      document.body.appendChild(copyInput)
      copyInput.select()
      document.execCommand("copy")
      this.$message({
        type: "success",
        message: "复制成功",
      })
      document.body.removeChild(copyInput)
    },
    // 活动报名
    handleApply() {
      this.$refs.dialogJoin.dialogopenbt()
    },
    cancelApply() {
      this.isJoin = true
      let params = {
        id: this.queryObj?.id ?? ""
      }
      revokeJoinActivity(params).then((res) => {
        this.isJoin = false
        if (res.code === 0) {
          this.formStatus = !this.formStatus
          this.$message.success('取消报名成功!')
          this.getInfo()
          this.getFormInfo()
        }
      }).catch(() => { })
    },
    // 采集到云库
    handleCollect() {
      this.isCollectLoad = true
      let params = {
        id: this.queryObj?.id ?? "",
        type: 3
      }
      setCollect(params).then((res) => {
        this.isCollectLoad = false
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: this.formCollect ? '取消采集成功!' : '采集成功!'
          })
          this.getInfo()
        }
      }).catch(() => { })
    },
    // 报名取消
    dialogCancle(formName) {
      this.isJoin = false
      this.$refs[formName].resetFields()
      this.$refs.dialogJoin.dialogclosebt()
    },
    //去登录
    handleLogin() {
      this.$router.push({ path: "/login" })
    },
    // 报名提交
    dialogSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isJoin) {
            return
          }
          this.isJoin = true
          let params = {
            id: this.queryObj?.id ?? "",
            status: 1,
          }
          let objFormList = []
          for (let index = 0; index < this.formList.length; index++) {
            let objItem = {}
            const item = this.formList[index]
            for (const key in this.ruleForm) {
              if (item.field_name === key) {
                objItem.user_form_value_id = item.user_form_value_id ? item.user_form_value_id : 0
                objItem.form_field_id = item.id
                objItem.content = item.field_name === '日期' ? (this.ruleForm[key] / 1000).toFixed() : this.ruleForm[key]
                objFormList.push(objItem)
              }
            }
          }
          params.form_list = objFormList
          joinActivity(params).then((res) => {
            this.isJoin = false
            if (res.code === 0) {
              this.formStatus = !this.formStatus
              this.$message.success('报名成功!')
              this.dialogCancle(formName)
            }
          }).catch(() => { })
        } else {
          return false
        }
      })
    },
    selectDate(val, inx) {
      let key = this.formList[inx].field_name
      this.ruleForm[key] = val
    },
    getUrl(obj, inx) {
      let key = this.formList[inx].field_name
      this.ruleForm[key] = JSON.parse(obj)
      this.formList[inx].fileList = JSON.parse(obj)
      // this.formList[inx].completed = true
      // this.$forceUpdate()
      // if (obj === "[]") {
      // } else {
      //   this.files = []
      //   this.formList[inx].completed = false
      //   const URL = JSON.parse(obj)
      //   let key = this.formList[inx].field_name
      //   if (this.sliceFiles) {
      //     let file = {}
      //     URL.forEach((item, index) => {
      //       if (index === 0) {
      //         file = item
      //       } else {
      //         file.size = file.size + item.size
      //       }
      //     })
      //     this.files.push(file)
      //   } else {
      //     this.files = URL
      //   }
      //   this.ruleForm[key] = this.files
      // }
      // console.log('this.ruleForm ------------ file', this.ruleForm)
    },
    async creatQrCode(url) {
      this.qrCode = await QRCode.toDataURL(url)

    },
    // 自动校正数据
    AutoCorrection(val) {
      let msg = symbolReverseEscape(val) // 特殊字符转译
      msg = clearHtmlString(msg) // 清理html字段
      // msg = clearHtmlPPTag(msg); // 清理多余P标签
      msg = arrangeImages(msg) // 处理图片
      msg = arrangeVideos(msg) // 处理视频
      return msg
    },
    //     // 分享到微信
    //     shareToWechat() {
    //       const shareUrl = `${request_base_path.pro_url}#/home/activity/detail?id=${this.queryObj.id}`
    //       const shareTitle = this.infoData.title || '活动详情'
    //       // 微信分享需要生成二维码，提示用户扫码分享
    //       this.$message({
    //         type: 'info',
    //         message: '请使用微信扫描二维码分享',
    //         duration: 3000
    //       })
    //     },
    //     // 分享到QQ
    //     shareToQQ() {
    //       console.log(this.infoData, this.infoData.end_time, dayjs.unix(this.infoData.start_time).format("YYYY-MM-DD HH:mm:ss"), '分享到QQ');
    //       const cover = this.infoData.cover || ''
    //       const shareUrl = 'https://cug-wenhua.kzmooc.cn/portal/#/home/activity/detail?id=' + this.queryObj.id
    //       const shareTitle = this.infoData.title || '活动详情'
    //       const shareDesc = '活动时间' + dayjs.unix(this.infoData.start_time).format("YYYY-MM-DD HH:mm:ss") + ' - ' + dayjs.unix(this.infoData.end_time).format("YYYY-MM-DD HH:mm:ss")
    //       // 'https://connect.qq.com/widget/shareqq/index.html?url=' + shareUrl + '&&title=' + shareTitle + '&desc=' + shareDesc
    //       // const qqShareUrl = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}&summary=${encodeURIComponent(shareDesc)}`
    //       const url = `https://connect.qq.com/widget/shareqq/index.html
    // ?title=${encodeURIComponent(shareTitle)}
    // &url=${encodeURIComponent(shareUrl)}
    // &summary=${encodeURIComponent(shareDesc)}
    // &pics=${encodeURIComponent(cover)}`.replace(/\n/g, '')
    //       window.open(url, '_blank', 'width=600,height=400')
    //     },
    //     // 分享到微博
    //     shareToWeibo() {
    //       const shareUrl = encodeURIComponent(`${request_base_path.pro_url}#/home/activity/detail?id=${this.queryObj.id}`)
    //       const shareTitle = encodeURIComponent(this.infoData.title || '活动详情')
    //       const weiboShareUrl = `https://service.weibo.com/share/share.php?url=${shareUrl}&title=${shareTitle}`
    //       window.open(weiboShareUrl, '_blank', 'width=600,height=400')
    //     },
  },
};
</script>
<style scoped lang="scss">
.page {
  .page-banner {
    width: 100%;
    height: 200px;
    background: #000 url(~@/assets/page/page_banner_bg.jpg) no-repeat;
    background-size: 100% 100%;
  }

  .page-body {
    width: 1200px;
    position: relative;
    margin: 0 auto;

    .panel {
      padding: 10px;
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 20px;

      .panel-head {
        padding: 10px;
      }

      .panel-title {
        color: #000;
        font-size: 24px;
        font-weight: bold;
        line-height: 40px;
      }

      .panel-body {
        padding: 10px;
      }
    }

    .panel-up {
      margin-top: -90px;
    }

    .panel-down {
      display: block;
    }

    .theme {
      display: flex;
      justify-content: space-between;
      align-items: stretch;

      .image {
        width: 500px;
        min-width: 500px;
        height: 300px;
        margin: 10px;
      }

      .info {
        // flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: stretch;
        padding: 10px 20px;
        width: calc(100% - 500px);
        box-sizing: border-box;

        .panel-title {
          line-height: 1.5;
        }

        .sec-box {
          margin-top: 12px;
          position: relative;

          .qrCode-box {
            position: absolute;
            right: 0px;
            top: 0px;

            .share-box {
              margin-top: 10px;
              text-align: center;

              .share-title {
                font-size: 12px;
                color: #999;
                margin-bottom: 8px;
              }

              .share-icons {
                display: flex;
                justify-content: center;
                gap: 12px;

                .share-item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  cursor: pointer;
                  padding: 6px 10px;
                  border-radius: 6px;
                  transition: all 0.3s;

                  &:hover {
                    background-color: #f5f5f5;
                    transform: translateY(-2px);
                  }

                  i {
                    font-size: 24px;
                    margin-bottom: 4px;
                  }

                  span {
                    font-size: 12px;
                    color: #666;
                  }
                }
              }
            }
          }
        }

        .category_name {
          display: inline-block;
          width: 80px;
          padding: 6px 10px;
          border-radius: 5px;
          background-color: #005cbb;
          color: #fff;
          font-size: 12px;
          box-sizing: border-box;
          text-align: center;
          font-weight: 500;
        }

        .msg-list {
          width: 100%;
          margin-bottom: 20px;

          .msg-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            line-height: 30px;
            height: 30px;

            .title {
              color: #000000;
              font-weight: 400;
              width: 200px;
              min-width: 200px;
              // text-align-last: justify;
              // margin-right: 10px;
            }

            .content {
              flex: 1;
              color: #333333;
              font-weight: 400;

              .liveBtn {
                padding: 0px;
              }
            }

            .icon {
              display: inline-block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              vertical-align: text-bottom;
              margin-right: 15px;
            }
          }
        }

        .action-btns {
          text-align: right;
        }
      }
    }

    .html-view {
      color: #333;
      font-size: 14px;
      font-weight: 400;
      line-height: 30px;
      overflow: hidden;
      /* 溢出隐藏 */
      position: relative;

      /* 子绝父相，这里是为了给伪元素设置定位*/
      p {
        padding: 0;
        margin-bottom: 5px;
      }

      img {
        display: block;
        max-width: 100%;
        margin: 10px auto;
      }
    }

    .poster-cont {
      margin-top: 26px;
    }
  }
}

// 二维码提示文字
.qrCode-tip {
  text-align: center;
  font-size: 12px;
  color: #005cbb;
  margin-top: 6px;
  cursor: pointer;
}

// 海报生成器：移出可视区域，但仍可被 html2canvas 捕获
.poster-maker {
  position: fixed;
  top: 0;
  left: -9999px;
  z-index: -1;
  width: 320px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;

  .poster-bg {
    position: relative;
    width: 320px;
    padding: 50px 16px 40px;
    background: url('~@/assets/bg.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
  }

  // 头像骑在卡片顶部边缘，放在卡片外层避免被 overflow 裁切
  .poster-avatar {
    position: absolute;
    top: 17px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 3px solid #ffffff;
    overflow: hidden;
    background-color: #ffffff;
    box-sizing: border-box;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .poster-card {
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    padding: 46px 16px 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    text-align: center;

    // 左侧蓝色半圆装饰
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      // background: #5b9cff;
      // border-radius: 50%;
    }

    // 右侧蓝色半圆装饰
    &::after {
      content: '';
      position: absolute;
      right: -10px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      // background: #5b9cff;
      // border-radius: 50%;
    }
  }

  .poster-author {
    font-size: 13px;
    color: #3b86ff;
    margin-bottom: 14px;
  }

  .poster-title {
    font-size: 22px;
    font-weight: bold;
    color: #333333;
    line-height: 1.4;
    margin-bottom: 16px;
  }

  // 标题与副标题之间的虚线分隔，两端带圆形装饰
  .poster-divider {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 0 20px;

    .line {
      flex: 1;
      height: 0;
      border-top: 2px dashed #d0d7e2;
    }

    .dot {
      position: absolute;
      top: 50%;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #62A1FD;
      transform: translateY(-50%);
      // opacity: 0.7;

      &.dot-l {
        left: -25px;
      }

      &.dot-r {
        right: -25px;
      }
    }
  }

  .poster-subtitle {
    font-size: 16px;
    color: #333333;
    line-height: 1.4;
    margin-bottom: 16px;
  }

  .poster-cover {
    width: 100%;
    height: 170px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 18px;
    background-color: #f5f5f5;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .poster-footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .poster-info {
      flex: 1;
      min-width: 0;
      padding-right: 6px;
      text-align: left;

      .poster-info-item {
        font-size: 11px;
        line-height: 1.9;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        .label {
          color: #666666;
        }

        .value {
          color: #333333;
        }
      }
    }

    .poster-qrcode {
      width: 78px;
      text-align: center;
      flex-shrink: 0;

      img {
        width: 70px;
        height: 70px;
        display: block;
        margin: 0 auto;
      }

      .poster-qrcode-tip {
        font-size: 10px;
        color: #999999;
        margin-top: 4px;
      }
    }
  }
}

// 海报预览弹窗
.poster-dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }

  ::v-deep .el-dialog__footer {
    padding: 10px 20px 20px;
  }

  .poster-preview {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f5f5f5;

    img {
      display: block;
    }
  }

  .poster-tip {
    text-align: center;
    font-size: 13px;
    color: #999999;
    cursor: pointer;
  }
}

// 弹窗
.dialog {
  .dialogBody {
    padding: 40px 0px 10px;
    width: 60%;
    margin: 0px auto;

    .form-box {
      // width: 400px;
      margin: 0 auto;

      .el-form-item {
        margin-right: 0px;
      }

      .time-content,
      .el-select {
        width: 100%;
      }
    }
  }

  ::v-deep .dialog-footer {
    height: auto !important;

    .dialogFoot {
      padding: 20px 20px 40px;
      text-align: center;
    }
  }
}

@media screen and (max-width: 640px) {
  .dialog {
    .dialogBody {
      width: 100%;
      padding: 20px 0px 10px;

      .form-box {
        padding-right: 20px;

        .el-form-item {
          ::v-deep .el-form-item__label {
            width: 80px !important;
          }

          ::v-deep .el-form-item__content {
            margin-left: 80px !important;
          }
        }
      }
    }

    ::v-deep .dialog-footer {
      .dialogFoot {
        padding: 10px 10px 20px;

        .el-button {
          padding: 10px 20px;
          font-size: 14px;
        }
      }
    }

    ::v-deep .dialog-title {
      margin-left: 15px;
      font-size: 15px;
    }
  }

  .page {
    .page-banner {
      height: 100px;
    }

    .page-body {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      .panel {
        padding: 10px;

        .panel-title {
          font-size: 18px;
          line-height: 1.4;
        }
      }

      .panel-up {
        margin-top: -30px;
      }

      .theme {
        flex-direction: column;

        .image {
          width: 100%;
          min-width: 100%;
          height: 200px;
          margin: 0 0 10px;
        }

        .info {
          width: 100%;
          padding: 10px 0;

          .msg-list {
            .msg-item {
              .title {
                width: auto;
                min-width: 80px;
              }
            }
          }

          .action-btns {
            display: grid;
            grid-template-columns: 1fr 1fr; // 两列布局
            grid-gap: 10px; // 设置列间距
            justify-items: center;
            margin-top: 20px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .page {
    .page-body {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;

      .theme {
        .image {
          width: 350px;
          min-width: 350px;
          height: 220px;
        }

        .info {
          width: calc(100% - 350px);
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}

::v-deep input[aria-hidden='true'] {
  display: none !important;
}

::v-deep.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>